import React, { useState } from 'react';
import { Input, Button, Form, message } from 'antd';
import axios from 'axios';
import { MemberLogin } from '../AllApi/UserApi/UserApi';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const LoginForm = () => {

  const navigate=useNavigate()
  const [loading, setLoading] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const response = await axios.post(MemberLogin, values); // Replace with your actual API endpoint
      if (response.data === 'NOTFOUND') {
      messageApi.error('Invalid login details!');
      }
      else if (response.data === 'ERROR') {
      messageApi.error('Error Occurred !');
      }
      else if (response.data !== null) {
        messageApi.success('Login successful!');
      
        sessionStorage.setItem("token", JSON.stringify(response.data.token));
        sessionStorage.setItem("userdata", JSON.stringify(response.data.userdata));
        sessionStorage.setItem("paymentDate", JSON.stringify(response.data.paymentDate));
        sessionStorage.setItem("status", JSON.stringify(response.data.status));

            if(response.data.status === 3){
              navigate('/userDashboard')
            }
            else if (response.data.status === 4) {
              navigate("/user/regForm");
            } else if (response.data.status === 5) {
              navigate("/user/regForm");
            } else if (response.data.status === 6) {
              navigate("/payment");
            } else if (response.data.status === 7) {
              toast.warn("Please wait for payment approval from the admin.", {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
              });
            } else if (response.data.status === 8) {
              navigate("/payment");
            } else if (response.data.status === 9) {
              navigate("/mainpage");
            } else {
              navigate("/");
            }

      }
    } catch (error) {
      messageApi.error(error || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {contextHolder}
      <Form layout="vertical" onFinish={onFinish}>
        <Form.Item
          name="email"
          label="Email or Mobile No."
          rules={[{ required: true, message: 'Please enter your email or mobile number' }]}
        >
          <Input />
        </Form.Item>

        <Form.Item
          name="password"
          label="Password"
          rules={[{ required: true, message: 'Please enter your password' }]}
        >
          <Input.Password />
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit" block loading={loading} className="loginBtn">
            LOG IN
          </Button>
        </Form.Item>
      </Form>
    </>
  );
};

export default LoginForm;
